import LibraryModule from '../index'

export default function (value, style = 'money') {
  const i18n = LibraryModule.i18n
  
  let localised = i18n.n( value/100, style )

  // POST PROCESSING...
  // The locale to use when searching for post processors. If the current locale does not supply the "money" format, use the fallback locale to find post processors 
  let ppLocale = i18n.numberFormats[i18n.locale] && i18n.numberFormats[i18n.locale][style] != null
    ? i18n.locale
    : i18n.fallbackLocale

  let postProcessors = _getPostProcessors(ppLocale, style, i18n.numberFormats[ppLocale][style].postProcessors)
  if(postProcessors) {
    postProcessors.forEach(p => localised = localised.replace(p.test, p.replace))
  }
  // END POST PROCESSING...

  return localised
}

var memcache = {}

/**
 * Compiles and caches raw post processor template strings into actual RegExp Objects.
 */
function _getPostProcessors(locale, format, raw) {
  if(!raw) return null

  let key = `${locale}-${format}`

  if (! memcache[key]) {
    memcache[key] = raw.map(processor => {
      return {
        test: new RegExp(processor.test, processor.flags),
        replace: processor.replace
      }
    })
  }
  return memcache[key]
}